import styled from "styled-components";
import UiButton from "../../../../components/Button";

export const Breadcrumb = styled("div")`
  font-size: 16px;
  line-height: 19px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const Link = styled("a")`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  margin-right: 24px;
  text-decoration: none;
  color: ${(props) => props.theme.colors.Primary};

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    font-size: 16px;
    line-height: 19px;
  }
`;

export const Button = styled(UiButton)`
  min-width: 288px;
  border-radius: 16px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    min-width: 318px;
  }
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin: 0px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    font-weight: 600;
    font-size: 36px;
    line-height: 44px;
    margin: 0px;
  }
`;

export const Text = styled("p")`
  margin-top: 0px;
  margin-bottom: 57px;
`;

export const Box = styled.div`
  padding: 11px;
`;
